import { oauthAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { domainToRegex } from "../urlPatternConversion";
import logo from "./logo.svg";

export const genesys = defineConnector({
  identifier: "genesys",
  name: "Genesys",
  tagLine: "Customer experience and contact center",
  logo,
  protocol: "http",
  tags: ["communication"],
  defaultUrlPattern: ({ region }) => domainToRegex(region),
  auth: oauthAuth,
  steps: [
    {
      title: "Select your region",
      items: [
        {
          kind: "markdown",
          content:
            "Log in to your [Genesys Cloud](https://login.mypurecloud.com/) account. Select the region that matches your organization.",
        },
        {
          kind: "select",
          label: "Region",
          required: true,
          target: { kind: "configuration", field: "region" },
          options: [
            { value: "mypurecloud.com", label: "Americas (US East)" },
            { value: "usw2.pure.cloud", label: "Americas (US West)" },
            { value: "cac1.pure.cloud", label: "Americas (Canada)" },
            { value: "sae1.pure.cloud", label: "Americas (São Paulo)" },
            { value: "mxc1.pure.cloud", label: "Americas (Mexico)" },
            { value: "mypurecloud.ie", label: "EMEA (Dublin)" },
            { value: "mypurecloud.de", label: "EMEA (Frankfurt)" },
            { value: "euw2.pure.cloud", label: "EMEA (London)" },
            { value: "euc2.pure.cloud", label: "EMEA (Zurich)" },
            { value: "mec1.pure.cloud", label: "EMEA (UAE)" },
            { value: "aps1.pure.cloud", label: "Asia Pacific (Mumbai)" },
            { value: "mypurecloud.jp", label: "Asia Pacific (Tokyo)" },
            { value: "apne2.pure.cloud", label: "Asia Pacific (Seoul)" },
            { value: "apne3.pure.cloud", label: "Asia Pacific (Osaka)" },
            { value: "apse1.pure.cloud", label: "Asia Pacific (Singapore)" },
            {
              value: "mypurecloud.com.au",
              label: "Asia Pacific (Sydney)",
            },
          ],
          defaultValue: "mypurecloud.com",
        },
      ],
    },
    {
      title: "Create an OAuth client",
      items: [
        {
          kind: "markdown",
          content:
            "In Genesys Cloud, go to **Admin → Integrations → OAuth** and create a new OAuth client with the **Client Credentials** grant type. Copy the client ID and client secret.",
        },
        {
          kind: "input",
          label: "Client ID",
          required: true,
          target: { kind: "oauthConnection", field: "clientId" },
        },
        {
          kind: "input",
          label: "Client secret",
          required: true,
          target: { kind: "oauthConnection", field: "clientSecret" },
        },
      ],
    },
  ],
  oauth: {
    grantType: () => "client_credentials",
    tokenEndpoint: ({ region }) => `https://login.${region}/oauth/token`,
    clientCredentialsFrom: "db",
    tokenEndpointAuthMethod: () => "client_secret_post",
    scopes: () => [],
  },
  connectionTest: {
    protocol: "http",
    request: ({ region }) => ({
      url: `https://api.${region}/api/v2/organizations/me`,
      expectedStatus: [200, 403],
    }),
  },
});
